<div nxRow>
    <div nxCol="12">
        <h2 nxHeadline="subsection-xsmall" class="nx-font-weight-semibold">{{ maInsuranceExtend.tariffDescLong }}
            ({{maInsuranceExtend.tariffCode}})</h2>
        <hr class="nx-margin-bottom-m">
    </div>
</div>